import * as authApi from "../api/authApi";

class AuthResponse {
  logIn = async (username, password) => {
    try {
      return await authApi.login(username, password);
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Ошибка входа";
      throw new Error(msg);
    }
  };

  async refresh() {
    return await authApi.refresh();
  }

  async logout() {
    return await authApi.logout();
  }
}

const authResponse = new AuthResponse();

export default authResponse;
